'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"boundary":"ErrorBoundary-module_boundary__ZhtF-","details":"ErrorBoundary-module_details__Qut5X"};

exports["default"] = style;
